import { compose, isEqual, negate, pick } from 'lodash/fp';
import { omitEmptyStrings } from '../../../../../utils/omit-empty-strings';
import { SellPersonEntity } from './sell-process-people-types';

export const personToPersonEntity: (person: any) => SellPersonEntity = compose(
  omitEmptyStrings,
  pick([
    'lastName',
    'firstName',
    'address',
    'city',
    'socialSecurityNumber',
    'postalCode',
    'personId',
  ]),
);

export const isEqualWithMapper = (
  mapFunction: (x: any) => any,
  a: unknown,
  b: unknown,
) => (mapFunction ? isEqual(mapFunction(a), mapFunction(b)) : isEqual(a, b));

export const shouldInsertIntoBatch = (
  mapFunction: (x: any) => any,
  inStore: SellPersonEntity | undefined,
  updater: SellPersonEntity,
) => {
  if (!inStore) {
    return true;
  }

  const isDifferentObject = negate(isEqualWithMapper);
  return isDifferentObject(mapFunction, inStore, updater);
};
